import {createActionCreator} from '../common/actions';
import {UserInfo} from '../users/selectors';

export const SubscribersWereFetched = createActionCreator<{jobID: JobID, subscribers: UserInfo[]}>('SUBSCRIBERS_WERE_FETCHED');
